import React from 'react'
import {
  Tooltip,
  Fade,
} from '@mui/material'
import {
  Done as DoneIcon,
} from '@mui/icons-material'

import { CopyIcon } from 'components/Icons/CopyIcon'
import { useClipboard, useToggle } from 'hooks'

type TPlacement = 'bottom-end'
| 'bottom-start'
| 'bottom'
| 'left-end'
| 'left-start'
| 'left'
| 'right-end'
| 'right-start'
| 'right'
| 'top-end'
| 'top-start'
| 'top'

interface ICopy {
  valueToCopy: string | number
  title: string
  tooltipPlacement?: TPlacement
}

const Copy: React.FC<ICopy> = ({
  valueToCopy,
  title,
  tooltipPlacement = 'right',
}) => {
  const [showSuccessIcon, toggleShowSuccessIcon] = useToggle()
  const [_, copyToClipboard] = useClipboard()

  const handleCopyValue = () => {
    const isCopySuccess = copyToClipboard(valueToCopy)

    if (isCopySuccess) {
      toggleShowSuccessIcon()

      setTimeout(() => {
        toggleShowSuccessIcon()
      }, 1500)
    }
  }

  return (
    <Tooltip
      title={showSuccessIcon ? 'Copiado!' : title}
      placement={tooltipPlacement}
    >
      <div style={{ margin: '0.3rem' }}>
        {showSuccessIcon
          ? (
            <Fade in={showSuccessIcon}>
              <DoneIcon fontSize="small" color="success" />
            </Fade>
          ) 
          : (
            <CopyIcon
              onClick={handleCopyValue}
              cursor="pointer"
              height={'20px'}
              width={'20px'}
            />
          )
        }
      </div>
    </Tooltip>
  )
}

export default Copy
